import React, { useEffect, useMemo, useRef, useState, useContext } from 'react';
import { isEqual, get } from 'lodash';
import AddToCartButton from '../../molecules/AddToCartButton/AddToCartButton';
import ProductOptions from '../ProductOptions/ProductOptions';
import Button from '../../atoms/Button/Button';
import Icon from '../../atoms/Icon/Icon';
import { getStorage } from '../../../helpers/general';
import AdjustItem from '../AdjustItem/AdjustItem';
import { Box, Flex, Input, Portal, Text, useMediaQuery, Radio, RadioGroup } from '@chakra-ui/react';
import WishlistButton from 'components/organisms/WishlistButton/WishlistButton';
import useSegment from 'hooks/useSegment';
import { useCartStore } from 'stores/cart';
import AutoshipIcon from '../../atoms/Icon/autoship';
import ReviewIcons from '../../atoms/ReviewIcons/ReviewIcons';
import BackInStock from '../BackInStock/BackInStock';
import Brand from '../ProductCard/brand';
import ProductNotice from '../ProductNotice/ProductNotice';
import ProductCartDetails from './ProductCartDetails';
import * as styles from './ProductDetails.module.scss';
import { useProductStore } from 'stores/product';
import { useParams } from 'hooks/useParams';
import AuthContext from 'context/AuthProvider';
import { useQuery } from '@tanstack/react-query';
import {
  addItemToNextOG,
  getSubscriptionItems,
  getOrders,
  createSubcription,
  closestItem,
  getSubcription,
  changeSubQty
} from 'common/orderGroove';
import AutoShipToolTip from '../AutoShip/AutoShipToolTip';
import ProductOGPopup from './ProductOGPopup';
import { AddToCartContainer, AutoShipBtnContainer } from './ProductDetails.styled';
import ProductGiftPopup from './ProductGiftPopup';


const ProductDetails = ({ product, variants, recommendations, modifiers, brand, giftProduct }) => {
  const auth = useContext(AuthContext);
  const { customerId, isLoggedIn } = get(auth, 'state', {});
  const [isPc] = useMediaQuery('(min-width: 500px)', {
    ssr: true,
    fallback: false
  });
  const defaultSku = useParams('sku');
  const defaultVariant = useParams('v');

  const { cartModal, setCartModal, setUpsellAction, giftModal, setGiftModal } = useCartStore(
    state => state
  );
  const { activeVariant, setActiveVariant } = useProductStore(state => state);

  const { track } = useSegment();
  const [modifiersValue, setModifiersValue] = useState({});
  const [itemInOG, setItemInOG] = useState([]);
  const [hideSWidget, sethideSWidget] = useState(false);

  const [modifierError, setModifierError] = useState([]);
  const [useAutoShip, setUseAutoShip] = useState(false);
  // const [maxQtyMessage, setMaxQtyMessage] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [priceObj, setPriceObj] = useState(product || {});
  const algoliaQueryId = getStorage('algoliaQueryId');
  const inStock = { available: 'in-stock' };
  const warranty = false;
  const [variantSpecs, setVariantSpecs] = useState([]);

  const [pageInit, setPageInit] = useState(false);
  const [openOGModal, setOpenOGModal] = useState(false);
  const [selectedOGDate, setSelectedOGDate] = useState('');
  const [oneTimeItemPurchase, setOneTimeItemPurchase] = useState(true);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [addingSub, setAddingSub] = useState(false);

  // const [variantOutOfStock, setVariantOutOfStock] = useState(false);
  const shippingOptionsAnchor = useRef();

  // /* Sticky Add to cart element */
  const [stickyCartMobile, setStickyCartMobile] = useState(false);
  const productOGId = product.entityId + '_' + activeVariant;

  // listen to anchor tags - sticky headers
  useEffect(() => {
    const handleScroll = () => {
      const offsetTop = shippingOptionsAnchor?.current?.offsetTop;

      if (!offsetTop) return;
      if (window.scrollY > offsetTop) {
        setStickyCartMobile(true);
        document.body.classList.add('sticky-footer-active');
        document.body.classList.add('parent-scroll-inactive');
      } else {
        setStickyCartMobile(false);
        document.body.classList.remove('sticky-footer-active');
        document.body.classList.add('parent-scroll-inactive');
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const {
    data: subscription,
    isFetching: fetchingSub,
    isFetched: fetchedSub,
    refetch: fetchSubInfo
  } = useQuery({
    queryKey: ['subscription', selectedOGDate],
    queryFn: () => getSubcription({ customerId, selectedOGDate }),
    enabled: !!customerId && customerId > 0 && selectedOGDate !== '',
    refetchOnWindowFocus: false,
    onError: error => {
      console.error('Query Error:', error);
    }
  });

  const { data: subscriptionItems, isFetched, isFetching, refetch } = useQuery({
    queryKey: ['subscriptionItem', customerId],
    queryFn: () => getSubscriptionItems({ customerId }),
    enabled: !!customerId && customerId > 0,
    refetchOnWindowFocus: false,
    onError: error => {
      console.error('Query Error:', error);
    }
  });

  const { data: nextOrders } = useQuery({
    queryKey: ['nextOrders', customerId],
    queryFn: () => getOrders(customerId),
    enabled: !!customerId && customerId > 0,
    refetchOnWindowFocus: false,
    onError: error => {
      console.error('Query Error:', error);
    }
  });

  useEffect(() => {
    if (subscriptionItems && subscriptionItems.products && fetchedSub && isFetched) {
      const findProductByIdAndType = (productsArray, productId, oneTimePurchase) => {
        const subscriptionType = oneTimePurchase === true ? 'oneTime' : 'subscription';
        const category = productsArray.find(cat => cat.subscription_type === subscriptionType);
        if (category) {
          return category.products.find(p => p.id === productId) || null;
        }
        return null;
      };
      const itemInNextOG = findProductByIdAndType(
        subscriptionItems.products,
        productOGId,
        oneTimeItemPurchase
      );

      if (itemInNextOG) {
        if (subscription) {
          itemInNextOG.subscription = subscription.public_id;
          itemInNextOG.quantity = subscription.quantity;
        }
        setItemInOG(itemInNextOG);
      }
    }
  }, [
    activeVariant,
    productOGId,
    isFetched,
    isFetching,
    fetchingSub,
    fetchedSub,
    subscriptionItems,
    subscription
  ]);

  const isImpulseUpsell = () => {
    let displayUpsell = false;
    const productOG = product.ordergrooveData.find(item => item.productExtraId === productOGId);
    if (productOG) {
      const ableToUpsell = productOG.groups.some(group => group.name === 'impulse_upsell') || false;
      const ableToCreateSub =
        productOG.groups.some(group => group.name === 'subscription') || false;
      if (isLoggedIn && !isOutOfStock && (ableToUpsell || ableToCreateSub)) {
        displayUpsell = { ableToUpsell, ableToCreateSub };
      }
    }
    return displayUpsell;
  };

  useEffect(() => {
    if (isLoggedIn && subscriptionItems) {
      setIsDataLoaded(true);
    }
  }, [isLoggedIn, subscriptionItems]);

  useEffect(() => {
    if (isDataLoaded) {
      const result = isImpulseUpsell();
      const isSubscription = result && !result.ableToUpsell;
      setOneTimeItemPurchase(!isSubscription);
    }
  }, [isDataLoaded]);

  const handleVariantChange = (id, tempVariant) => {
    const findVariant = variants?.find(product =>
      product.option_values.some(option => option.id === tempVariant.id)
    );
    const newVariantSpecs = variantSpecs.map(variant => {
      if (id === variant.option_id) {
        return {
          id: tempVariant.id,
          label: tempVariant.label,
          option_display_name: variant.option_display_name,
          option_id: variant.option_id
        };
      } else {
        return variant;
      }
    });
    if (findVariant) {
      setPriceObj({ ...findVariant, priceOptions: { override: true } });
    }

    setVariantSpecs(newVariantSpecs);
  };

  const productOptionsSorted = product?.options?.map(item => ({
    ...item,
    option_values: [...item.option_values].sort((a, b) => a.sort_order - b.sort_order)
  }));

  const fixedFutureAutoShipDiscont = 5;
  const dinnerBowlProduct = 163;
  const inventoryCount =
    product &&
    typeof product.inventory_tracking !== 'undefined' &&
    typeof product.inventory_level !== 'undefined' &&
    typeof product.inventory_warning_level !== 'undefined' &&
    product.inventory_tracking !== 'none'
      ? product.inventory_level
      : false;

  const selectedVariant = useMemo(() => {
    let findVariant = undefined;

    if (activeVariant && typeof activeVariant === 'number') {
      findVariant = variants?.find(variant => variant.id === activeVariant);
    }
    return findVariant;
  }, [activeVariant, variants]);

  const isOutOfStock =
    product.inventory_tracking !== 'none' &&
    (product.inventory_level === 0 || selectedVariant?.inventory_level === 0);

  useEffect(() => {
    if (
      product &&
      typeof product.inventory_tracking !== 'undefined' &&
      typeof product.inventory_level !== 'undefined' &&
      typeof product.inventory_warning_level !== 'undefined' &&
      product.inventory_tracking === 'product' &&
      product.inventory_level < 1
    ) {
      setQuantity(0);
    }

    // Set active variant
    if (product && variants?.length > 0 && !activeVariant) {
      let variantInStock = variants[0];

      if (product.inventory_tracking !== 'none') {
        const findVariantInStock = variants.find(variant => variant.inventory_level > 0);
        if (findVariantInStock) variantInStock = findVariantInStock;
      }

      //override this by default variant
      if (defaultSku) {
        const findDefault = variants.find(variant => variant.sku === defaultSku);

        if (findDefault) {
          variantInStock = findDefault;
        }
      }
      if (defaultVariant) {
        const variantSelect = variants.find(v => v.id === Number(defaultVariant));
        if (variantSelect) {
          variantInStock = variantSelect;
        }
      }

      setActiveVariant(variantInStock?.entityId || variantInStock?.id);
      setVariantSpecs(variantInStock?.option_values);
      setPriceObj({
        ...variantInStock,
        priceOptions: { override: variants?.length > 1 ? true : false }
      });

      // setStockObj({ ...variants[0], availability: product.availability});
    } else if (product && variants?.length === 0 && !activeVariant) {
      setActiveVariant(true);
      // setStockObj(product);
    }

    // Page init functions
    if (!pageInit) {
      setActiveVariant(false);
      setPageInit(true);
      // Open first description accordion at page load
      const description = document.querySelector('[data-description]');
      if (description) {
        const h4s = description.querySelectorAll('h4');
        if (h4s.length > 0) {
          h4s[0].classList.toggle('open');
          let nextElement = h4s[0].nextElementSibling;
          while (nextElement && !nextElement.matches('h4')) {
            nextElement.classList.toggle(styles.active);
            nextElement = nextElement.nextElementSibling;
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product, pageInit, activeVariant, defaultSku, defaultVariant]);

  useEffect(() => {
    const tempActiveVariant =
      variants && Array.isArray(variants)
        ? variants.filter(variant => isEqual(variant.option_values, variantSpecs))
        : [];
    if (tempActiveVariant !== undefined && tempActiveVariant?.length !== 0) {
      let assignVariant = tempActiveVariant[0];
      setActiveVariant(assignVariant?.entityId || assignVariant?.id);
    }
  }, [variantSpecs, variants]);

  const updateQuantity = quantity => {
    // let maxQtyMessage = false;

    if (inventoryCount && quantity > inventoryCount) {
      // quantity = inventoryCount;
      // maxQtyMessage = `Only ${inventoryCount} available`;
    } else if (quantity < 1) {
      quantity = 1;
    }

    // setMaxQtyMessage(maxQtyMessage);
    setQuantity(quantity);
  };

  function handleReviewLinkClick(event) {
    event.preventDefault(); // prevent default behavior

    const targetElement = document.querySelector('#reviews');

    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop - 100, // adjust scroll position with -100 offset
        behavior: 'smooth'
      });
    }
  }

  const { autoship, autoShipDiscount, futureDiscount } = useMemo(() => {
    const findAutoship = product.modifiers?.find(modifier => modifier.name === 'Ships Every');

    if (findAutoship) {
      const less = findAutoship.option_values?.[0]?.adjusters?.price?.adjuster_value * -1;

      let discountedPrice = priceObj.calculated_price;
      if (less) {
        const discountAmount = priceObj.calculated_price * (less / 100);
        discountedPrice = priceObj.calculated_price - discountAmount;
      }
      const futureDiscountPrice =
        priceObj.calculated_price - priceObj.calculated_price * (fixedFutureAutoShipDiscont / 100);

      return {
        autoship: discountedPrice?.toFixed(2) ?? 0,
        autoShipDiscount: isNaN(less) ? 0 : less,
        futureDiscount: futureDiscountPrice?.toFixed(2) ?? 0
      };
    }

    return {
      autoship: 0,
      autoShipDiscount: 0
    };
  }, [priceObj, product?.modifiers]);

  const isAutoship = useMemo(() => {
    const findAutoship = product.modifiers?.find(modifier => modifier.name === 'Ships Every');
    return !!findAutoship;
  }, [product]);

  const { isCold, isMedication, notice } = useMemo(() => {
    let notice = '';
    let isCold = false;
    let isMedication = false;
    let isVetDiet = false;
    let isVetProduct = false;

    const productTypeField = product.custom_fields?.filter(field => field.name === 'Product Type');
    productTypeField?.forEach(field => {
      switch (field.value) {
        case 'Cold Shipping':
          isCold = true;
          break;
        case 'Medication':
          isMedication = true;
          break;
        case 'Veterinary Diet':
          isVetDiet = true;
          break;
        case 'Veterinary Product':
          isVetProduct = true;
          break;
        default:
          break;
      }
    });

    if (isCold && isMedication) notice = 'cold';
    else if (isVetDiet) notice = 'vet';
    else if (isVetProduct) notice = 'vetProduct';
    else if (isMedication) notice = 'medication';

    return { isCold, isMedication, notice };
  }, [product]);

  const thumbnail = useMemo(() => {
    const thumbnail = product.images?.find(image => image.is_thumbnail);
    return thumbnail?.url_standard ?? '/404.svg';
  }, [product]);

  const modifiersDisplay = useMemo(() => {
    return modifiers?.filter(
      i =>
        ![
          'Ships Every',
          'Upload Prescription',
          'Prescription Status',
          'Cold Shipping Terms & Conditions'
        ].some(term => i.name.includes(term))
    );
  }, [modifiers]);

  const options = useMemo(() => {
    const collection = [];

    if (modifiersDisplay && modifiersDisplay.length > 0) {
      modifiersDisplay.forEach(m =>
        collection.push({
          option_id: m?.id,
          option_value: modifiersValue[m?.name] || ''
        })
      );
      if (selectedVariant?.option_values?.length > 0) {
        collection.push({
          option_id: selectedVariant?.option_values?.[0]?.option_id,
          option_value: selectedVariant?.option_values?.[0]?.id
        });
      }
    }
    if (useAutoShip) {
      const variantSelected = product.variants.find(item => item.id === activeVariant);

      if (variantSelected && variantSelected.option_values?.[0]) {
        collection.push({
          option_id: variantSelected.option_values[0].option_id,
          option_value: variantSelected.option_values[0].id
        });
      }

      const autoShipOption = product.modifiers.find(i => i.name === 'Ships Every');
      if (autoShipOption) {
        const defaultFrequency = '4 Weeks';
        const findOption = autoShipOption.option_values?.find(
          item => item.label === defaultFrequency
        );
        const selectFrequency = findOption ?? autoShipOption.option_values[0];

        if (selectFrequency) {
          collection.push({
            option_id: selectFrequency.option_id,
            option_value: selectFrequency.id
          });
        }
      }
    }
    return collection;
  }, [modifiersDisplay, modifiersValue, selectedVariant, useAutoShip]);

  const trackAddToCart = (eventName = 'Product Added') => {
    const variant = selectedVariant?.option_values?.map(option => option.label).join(', ');
    //track option if added autoship
    track(eventName, {
      product_id: product.entityId,
      name: product.name,
      sku: product.sku,
      price: product.price,
      quantity: quantity,
      currency: 'AUD',
      category: product?.categories?.map(category => category.name).join(', '),
      brand: product?.brand_id,
      variant: `${variant ? variant : 'Default Variant'} (${activeVariant})`,
      url: product.custom_url.url,
      product_type: isMedication ? 'Medication' : 'OTC',
      image_url: thumbnail,
      algolia_query_id: algoliaQueryId
    });
  };

  const giftProductId = useMemo(() => {
    const isGift = giftProduct?.custom_fields?.find(
      field => field.name === 'isGift' && field.value === 'true'
    );
    if (giftProduct && giftProduct.id && isGift) {
      return giftProduct.id;
    }
    return 0;
  }, [giftProduct]);

  const reviews = isNaN(product.reviews_rating_sum / product.reviews_count)
    ? 0
    : (product.reviews_rating_sum / product.reviews_count).toFixed(1);

  const haveAutoShipDiscount = !!autoShipDiscount && autoShipDiscount > 0 && !isNaN(autoship);

  const onAddToSubscription = async () => {
    setAddingSub(true);
    const orderOGId = subscriptionItems ? subscriptionItems.order : null;
    if (orderOGId) {
      const currentItem = subscriptionItems.products.find(i => i.id === productOGId);
      const itemDetails = {
        productId: productOGId,
        quantity: quantity
      };
      if (nextOrders && nextOrders.length && selectedOGDate !== '') {
        const nextOG = closestItem(nextOrders);
        if (nextOG) {
          if (subscription) {
            const requestData = {
              id: subscription.public_id,
              quantity: subscription.quantity + itemDetails.quantity
            };
            await changeSubQty(requestData, customerId);
          } else {
            await createSubcription({
              orderOGId,
              itemDetails,
              customerId,
              merchant: nextOG.merchant,
              payment: nextOG.payment,
              shipping_address: nextOG.shipping_address,
              every: selectedOGDate
            });
          }
        }
      } else {
        if (currentItem) {
          await addItemToNextOG({ currentItem, customerId });
        } else {
          await addItemToNextOG({ orderOGId, itemDetails, customerId });
        }
      }
      await fetchSubInfo();
      await refetch();
      sethideSWidget(true);
      setAddingSub(false);
      trackAddToCart('Upsell Product Added');
      setOpenOGModal(false);
      setUpsellAction(true);
      setCartModal(true);
    }
  };

  const onModifiersChange = (value, name) => {
    const currentModifiers = { ...modifiersValue };
    currentModifiers[name] = value;
    setModifiersValue(currentModifiers);
  };

  const getNextAutoShipDate = (mobileDate = false) => {
    if (nextOrders && nextOrders.length) {
      const format = {
        month: 'short',
        day: '2-digit'
      };
      if (!mobileDate) format.year = 'numeric';
      const formattedPlace = new Date(closestItem(nextOrders)?.place).toLocaleDateString(
        'en-US',
        format
      );
      return formattedPlace;
    }
    return '';
  };

  const AddToNextOGBtn = () => {
    if (!isImpulseUpsell()) return <></>;
    return (
      <AutoShipBtnContainer $isMobile={!isPc}>
        <Button
          level={'primary'}
          type="buttonSubmit"
          disabled={addingSub}
          onClick={() => {
            setSelectedOGDate('');
            setOpenOGModal(true);
          }}
        >
          <span>Add to next Autoship</span>
        </Button>
      </AutoShipBtnContainer>
    );
  };
  const onValidateModifiers = () => {
    const modifiersData = product.modifiers;
    const mappedValue = modifiersData.map(modifier => {
      const value = modifiersValue[modifier.name];
      if (modifier.display_name.includes("Pet's Name")) {
        modifier.required = true;
      }
      return { ...modifier, selectedValue: value || null };
    });

    const requiredModifiers = mappedValue.filter(
      i => (!i.selectedValue || i.selectedValue.trim() === '') && i.required
    );
    setModifierError(requiredModifiers);
    return requiredModifiers;
  };
  return (
    <>
      <div className={styles.productDetails}>
        {/* Brand */}
        {/* {brandImage && (

            )} */}
        <div className={styles.brandLogoContainer}>
          <Brand brandData={brand} />
        </div>
        {/* Title Container */}
        <div className={styles.titleContainer}>
          <div>
            <h1 className="h3">{product && product.name}</h1>
          </div>
          <div className={styles.wishIconContainer}>
            <div>
              <WishlistButton
                productId={product.entityId || product.id}
                variantId={activeVariant}
              />
            </div>
          </div>
        </div>

        {/* Review and Inventory Check */}
        <div className={styles.reviewInventoryCheck}>
          <Flex
            as={'a'}
            mb={4}
            alignItems={'center'}
            gap={2}
            href="#reviews"
            onClick={handleReviewLinkClick}
          >
            <ReviewIcons rating={reviews} gap={'4px'} /> {reviews} ({product.reviews_count})
            <a
              href="#reviews"
              onClick={handleReviewLinkClick}
              className={`underline ${styles.reviewLink}`}
            >
              Write review
            </a>
          </Flex>
        </div>

        {isMedication && (
          <Flex gap={3}>
            <Icon symbol="prescription" />
            <Box className={styles.isMedication}>
              <Text className="title">Prescription Medication</Text>
              <Text className="subtitle">You will be required to provide a prescription</Text>
            </Box>
          </Flex>
        )}

        {isCold && (
          <Flex gap={3}>
            <Icon symbol="cold" />
            <Box className={styles.isCold}>
              <Text className="title">cold shipping</Text>
              <Text className="subtitle">Terms & conditions apply</Text>
            </Box>
          </Flex>
        )}

        {modifiersDisplay &&
          modifiersDisplay
            .sort((a, b) => a.sort_order - b.sort_order)
            .map((m, index) => (
              <div key={`modifiers-` + index}>
                <Text className={styles.label}>
                  {m.display_name.includes("Pet's Name") ? "Pet's Name" : m.display_name}
                </Text>
                <Input
                  placeholder={m.display_name}
                  isInvalid={modifierError.find(error => error.name === m.name)?.required}
                  value={modifiersValue[m.name]}
                  onChange={e => {
                    const currentItem = modifierError.find(error => error.name === m.name);
                    if (currentItem) {
                      const newModifierError = modifierError.filter(
                        item => item.name !== currentItem.name
                      );
                      setModifierError(newModifierError);
                    }
                    onModifiersChange(e.target.value, m.name);
                  }}
                  mb={4}
                  bg={'white'}
                  fontSize={isPc ? 'sm' : 16}
                />
              </div>
            ))}

        {product.warranty && (
          <div key="warranty" className={styles.warranty}>
            {product.warranty}
          </div>
        )}
        {/* PRODUCT VARIANT SELECTIONS */}
        {productOptionsSorted && productOptionsSorted?.length > 0 && (
          <ProductOptions
            options={productOptionsSorted}
            variantSpecs={variantSpecs}
            variants={variants}
            track={product.inventory_tracking !== 'none'}
            handleVariantChange={handleVariantChange}
          />
        )}
        {isOutOfStock && (
          <BackInStock product={product} variant={activeVariant} className={styles.outOfStock} />
        )}
        <RadioGroup defaultValue="normal" onChange={e => setUseAutoShip(e === 'autoship')}>
          <div
            className={`${styles.autoShipContainer} ${(!isAutoship || isOutOfStock) &&
              styles.noAutoShip}`}
          >
            <Radio value="normal">
              <Flex justifyContent="space-between" alignItems="center" w="full">
                <Text
                  fontWeight={'semibold'}
                  fontSize={16}
                  color={'#4B5661'}
                >
                  {isAutoship ? 'Once only' : 'Price'}
                </Text>
                <Flex gap={4} alignItems={'center'}>
                  {priceObj?.price > priceObj.calculated_price && (
                    <Text color={'var(--font-gray)'} textDecor={'line-through'}>
                      ${priceObj.price.toFixed(2)}
                    </Text>
                  )}
                  <Text
                    fontSize={21}
                    fontWeight={'semibold'}
                    color={
                      priceObj?.price > priceObj.calculated_price
                        ? 'var(--standard-red)'
                        : 'var(--greyscale-dark-4x)'
                    }
                  >
                    $
                    {isOutOfStock
                      ? priceObj.calculated_price?.toFixed(2)
                      : priceObj.calculated_price?.toFixed(2) ?? product?.retail_price?.toFixed(2)}
                  </Text>
                </Flex>
              </Flex>
            </Radio>
            {isAutoship && !isOutOfStock && (
              <Radio value="autoship">
                <div className="discount">
                  <AutoshipIcon />
                  <div className="discount-prices">
                    {haveAutoShipDiscount && (
                      <div className="save-percent">Save {autoShipDiscount ?? 0}%</div>
                    )}
                  </div>
                </div>
                {autoShipDiscount <= fixedFutureAutoShipDiscont ||
                product.brand_id === dinnerBowlProduct ? (
                  <div>
                    <div className="autoship-description one-discount">
                      <div>
                        {haveAutoShipDiscount ? (
                          <div className="note">Save {autoShipDiscount ?? 0}% ongoing</div>
                        ) : (
                          <AutoShipToolTip />
                        )}
                      </div>
                      <div className="discount-prices">
                        <div className="save-price">${autoship}</div>
                      </div>
                    </div>
                    {haveAutoShipDiscount && <AutoShipToolTip />}
                  </div>
                ) : (
                  <div>
                    <div className="autoship-description">
                      <div>
                        <div className="title">First delivery</div>
                        {haveAutoShipDiscount && (
                          <div className="note">Save {autoShipDiscount ?? 0}%</div>
                        )}
                      </div>
                      <div className="discount-prices">
                        <div className="save-price">${autoship}</div>
                      </div>
                    </div>
                    <div className="autoship-description">
                      <div>
                        <div className="title">Future deliveries</div>
                        <div className="note">Save {fixedFutureAutoShipDiscont}%</div>
                      </div>
                      <div className="discount-prices">
                        <div className="save-price">${futureDiscount}</div>
                      </div>
                    </div>
                    <AutoShipToolTip />
                  </div>
                )}
              </Radio>
            )}
          </div>
        </RadioGroup>

        {/* Checkout Container */}
        {product.availability === 'disabled' ? (
          <AddToCartContainer>
            <Button level="primary" size="fullWidth" href="https://petchemist.brainfish.ai/">
              Contact us
            </Button>
          </AddToCartContainer>
        ) : (
          <>
            <div className={styles.checkoutContainer}>
              <div className={styles.checkoutContent}>
                <div className={styles.qtyContainer}>
                  <AdjustItem
                    isCart={false}
                    count={quantity}
                    setItemCount={updateQuantity}
                    item={product}
                  ></AdjustItem>
                </div>
                <AddToCartContainer>
                  <AddToCartButton
                    fullWidth
                    product={product}
                    needModifiers={onValidateModifiers}
                    options={options}
                    tracker={trackAddToCart}
                    selectedVariant={selectedVariant}
                    track={product.inventory_tracking !== 'none'}
                    disabled={isOutOfStock}
                    productId={product.entityId || product.id}
                    variantId={activeVariant}
                    intercept={!!notice}
                    quantity={quantity}
                    extraItems={warranty ? [{ productId: warranty, matchQty: true }] : []}
                    giftProductId={giftProductId}
                  >
                    {inStock?.available === 'no-stock'
                      ? 'Out of Stock'
                      : inStock?.available === 'po-stock'
                      ? 'Pre-Order'
                      : 'Add to cart'}
                  </AddToCartButton>
                  <AddToNextOGBtn />
                </AddToCartContainer>
              </div>
            </div>

            <div className={styles.shippingOptionsContainer} ref={shippingOptionsAnchor}></div>
          </>
        )}
      </div>
      <ProductCartDetails
        isOpen={cartModal}
        recommendations={recommendations}
        orderGrooveItem={itemInOG || null}
        customerId={customerId}
        fetchOGItem={refetch}
        fetchSubItem={fetchSubInfo}
        thumbnail={thumbnail}
        product={product}
        priceObj={priceObj}
        selectedVariant={variantSpecs[0]}
        useAutoShip={useAutoShip}
        isMedication={isMedication}
        styles={styles}
        oneTimeItemPurchase={oneTimeItemPurchase}
        hideSWidget={hideSWidget}
        sethideSWidget={sethideSWidget}
      />
      {notice && (
        <ProductNotice content={notice}>
          <AddToCartButton
            options={options}
            buttonStyle="tertiary"
            tracker={trackAddToCart}
            productId={product.entityId || product.id}
            variantId={activeVariant}
            quantity={quantity}
            intercept={!!notice}
            extraItems={warranty ? [{ productId: warranty, matchQty: true }] : []}
            product={product}
            giftProductId={giftProductId}
          >
            {inStock?.available === 'no-stock'
              ? 'Out of Stock'
              : inStock?.available === 'po-stock'
              ? 'Pre-Order'
              : 'I Agree'}
          </AddToCartButton>
        </ProductNotice>
      )}
      <Portal>
        <div
          className={`
        ${styles.stickyFooter}
        ${stickyCartMobile === true ? styles.stickyFooterActive : ''}
            `}
        >
          {isOutOfStock ? (
            <BackInStock
              product={product}
              variant={activeVariant}
              className={styles.outOfStockMobile}
            />
          ) : (
            <>
              <AdjustItem
                isCart={false}
                count={quantity}
                setItemCount={e => updateQuantity(e)}
                item={product}
              />
              <div className={styles.stickyFooterButtonContainer}>
                <AddToCartButton
                  tracker={trackAddToCart}
                  productId={product.entityId || product.id}
                  fullWidth
                  variantId={activeVariant}
                  quantity={quantity}
                  intercept={!!notice}
                  extraItems={warranty ? [{ productId: warranty, matchQty: true }] : []}
                  product={product}
                  giftProductId={giftProductId}
                >
                  {inStock?.available === 'no-stock'
                    ? 'Out of Stock'
                    : inStock?.available === 'po-stock'
                    ? 'Pre-Order'
                    : 'Add to cart'}
                </AddToCartButton>
              </div>
            </>
          )}
        </div>
      </Portal>
      <ProductOGPopup
        nextOGDate={getNextAutoShipDate}
        addToOGAction={onAddToSubscription}
        openOGModal={openOGModal}
        setOpenOGModal={setOpenOGModal}
        selectedOGDate={selectedOGDate}
        setSelectedOGDate={setSelectedOGDate}
        isImpulseUpsell={isImpulseUpsell}
        setOneTimeItemPurchase={setOneTimeItemPurchase}
        oneTimeItemPurchase={oneTimeItemPurchase}
        isFetching={addingSub || fetchingSub}
      />
      <ProductGiftPopup
        giftModal={giftModal}
        setGiftModal={setGiftModal}
        giftProduct={giftProduct}
      />
    </>
  );
};
export default ProductDetails;
